module.exports = __webpack_public_path__ + "static/media/based_banner.8cdf3638.png";